import { NodeSelection } from 'tiptap'
import { Image } from 'tiptap-extensions'

export default class Figure extends Image {
  get name() {
    return 'figure'
  }

  get schema() {
    return {
      attrs: {
        src: {
          default: null,
        },
        alt: {
          default: '',
        },
        width: {
          default: '',
        },
        align: {
          default: 'center',
        },
        href: {
          default: '',
        },
      },
      group: 'block',
      draggable: true,
      selectable: true,
      parseDOM: [
        {
          tag: 'figure',
          getAttrs: (dom) => ({
            width: dom.getElementsByTagName('img')[0].getAttribute('width'),
            src: dom.getElementsByTagName('img')[0].getAttribute('src'),
            alt: dom.getElementsByTagName('img')[0].getAttribute('alt'),
            align: dom.getElementsByTagName('img')[0].dataset.align,
            href: dom.getElementsByTagName('img')[0].dataset.href,
          }),
        },
      ],
      toDOM: (node) => [
        'figure',
        {
          class: `motyro-figure align-${node.attrs.align}`,
        },
        [
          node.attrs.href ? 'a' : 'div',
          {
            href: node.attrs.href ? node.attrs.href : null,
            target: node.attrs.href ? '_blank' : null,
          },
          [
            'img',
            {
              width: node.attrs.width,
              src: node.attrs.src,
              alt: node.attrs.alt,
              'data-align': node.attrs.align,
              'data-href': node.attrs.href,
            },
          ],
          [
            'figcaption',
            {
              class: 'motyro-figure__Caption',
            },
            node.attrs.alt,
          ],
        ],
      ],
    }
  }

  get view() {
    return {
      props: ['node', 'updateAttrs', 'view', 'selected', 'getPos'],
      data() {
        return {
          showLinkMenu: false,
        }
      },
      computed: {
        src() {
          return this.node.attrs.src
        },
        align: {
          get() {
            return this.node.attrs.align
          },
          set(align) {
            this.updateAttrs({ align })
          },
        },
        linkUrl: {
          get() {
            return this.node.attrs.href
          },
          set(href) {
            this.updateAttrs({ href })
          },
        },
        alt: {
          get() {
            return this.node.attrs.alt
          },
          set(alt) {
            this.updateAttrs({ alt })
          },
        },
        styles: {
          get() {
            return {
              width: this.node.attrs.width,
            }
          },
          set(width) {
            this.updateAttrs({ width })
          },
        },
      },
      methods: {
        onResize() {
          const width = this.$refs.figure.clientWidth + 2
          this.styles = width
        },
        makeNodeSelection() {
          let tr = this.view.state.tr
          const pos = this.getPos()
          let pos1 = this.view.state.doc.resolve(pos)
          let selection = new NodeSelection(pos1)
          tr.setSelection(selection)
          this.view.dispatch(tr)
        },
      },
      template: `
        <figure class="motyro-embed--Figure" :class="['align-' + align, { 'is-Selected': selected }]" ref="figure" @mouseup="onResize" :style="{ width: styles.width + 'px' }" @click="makeNodeSelection">
          <div class="menububble--Embed">
            <template v-if="showLinkMenu">
              <form class="menububble__Form" @submit.prevent="showLinkMenu = false">
                <input class="menububble__Input" type="text" v-model="linkUrl" placeholder="https://" @keydown.esc="showLinkMenu = false" @paste.stop />
                <button
                  class="menububble__Button"
                  @click="showLinkMenu = false"
                  type="button"
                >
                  <icon
                    name="check"
                    weight="regular"
                  />
                </button>
              </form>
            </template>
            <template v-else>
              <button type="button" class="menububble__Button" @click="linkUrl = ''" v-if="linkUrl.length > 0">
                <span>Remove link</span>
                <icon name="unlink" />
              </button>
              <button type="button" class="menububble__Button" @click="showLinkMenu = true">
                <span v-if="linkUrl.length > 0">Update link</span>
                <span v-else>Add link</span>
                <icon name="link" />
              </button>
            </template>

            <button type="button" class="menububble__Button" @click="align = 'left'" :class="{ 'is-Active': align === 'left' }"><icon name="align-left" /></button>
            <button type="button" class="menububble__Button" @click="align = 'center'" :class="{ 'is-Active': align === 'center' }"><icon name="align-center" /></button>
            <button type="button" class="menububble__Button" @click="align = 'right'" :class="{ 'is-Active': align === 'right' }"><icon name="align-right" /></button>
          </div>
          <img :data-align="align" class="motyro-embed__Image" ref="image" :src="src" :alt="alt">
          <figcaption><input class="motyro-embed__Input" @paste.stop placeholder="Enter caption or leave blank" v-model="alt" /></figcaption>
        </figure>
      `,
    }
  }

  commands({ type }) {
    return (attrs) => (state, dispatch) => {
      const { selection } = state
      const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos
      const node = type.create(attrs)
      const transaction = state.tr.insert(position, node)
      dispatch(transaction)
    }
  }
}
